module.exports = __webpack_public_path__ + "static/media/1024584.0eab6cb2.jpg";